module.exports = __webpack_public_path__ + "img/candela-apps-light-01.b2e97947.png";